import { api } from '../index';

const prefix = '/api/slip/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiSelectSlipList(param) {
	return api.post(prefix + 'selectSlipList', param);
}

export function apiSelectSlip(param) {
	return api.post(prefix + 'selectSlip', param);
}

export function apiSelectSlipItemList(slip_no) {
	return api.get(prefix + 'selectSlipItemList', { params: { slip_no } });
}

// export function apiSelectInvoiceItemList(param) {
// 	return api.post(prefix + 'selectInvoiceItemList', param);
// }

// export function apiSelectInvoiceHistoryItemList(param) {
// 	return api.post(prefix + 'selectInvoiceHistoryItemList', param);
// }

export function apiInsertSlip(param) {
	param.mode = 'insert';
	return apiSubmitSlip(param);
	//return api.post(prefix + 'submitInvoice', param);
}

export function apiUpdateSlip(param) {
	param.mode = 'update';
	//console.log(param);
	return apiSubmitSlip(param);
	//return api.post(prefix + 'submitUser', param);
}

export function apiUpdateSlipPrint(slip_no) {
	return api.get(prefix + 'updateSlipPrint', { params: { slip_no } });
}

// // export function apiDeleteUser(param) {
// // 	param.mode = 'delete';
// // 	return api.post(prefix + 'submitUser', param);
// // }

function apiSubmitSlip(param) {
	return api.post(prefix + 'submitSlip', param);
}

export function apiApplyInventory(param) {
	return api.post(prefix + 'applyInventory', param);
}
